module.exports = __webpack_public_path__ + "img/logo.cc12cc62.webp";